import endCard from "./end-card.vue";

let Plugin = {},
  vueClass = Vue.extend(endCard),
  vueInstance;

Plugin.install = function(Vue, opt) {
  opt.root.endCardsConfirm = function() {
    // if (!vueInstance) {
      let el = document.createElement("div");
      document.querySelector("body").appendChild(el);

      vueInstance = new vueClass({
        el: el,
        router: opt.router,
      });
    // }

    return vueInstance.show(...arguments);
  };
};

export default Plugin;
